import React from 'react';

interface LabelProps
  extends React.DetailedHTMLProps<
    React.LabelHTMLAttributes<HTMLLabelElement>,
    HTMLLabelElement
  > {}

export default function Label({
  children,
  htmlFor,
  className,
  ...props
}: LabelProps): JSX.Element {
  return (
    <label {...props} className={className ? className : 'title-label'}>
      {children}
    </label>
  );
}
